import { useStaticQuery, graphql } from 'gatsby';

export const useMainMenu = () => {
  const { menuConfiguration } = useStaticQuery(
    graphql`
      query MainMenuQuery {
        menuConfiguration: allStoryblokEntry(
          filter: { field_component: { eq: "configuration_menu" } }
        ) {
          edges {
            node {
              content
              lang
            }
          }
        }
      }
    `,
  );
  const res = menuConfiguration.edges.find(
    (n) => n.node.lang === process.env.GATSBY_STORYBLOK_LANGUAGE,
  );

  return res.node;
};
